import { render } from "./Register_1.vue?vue&type=template&id=b5d65162&scoped=true"
import script from "./Register_1.vue?vue&type=script&lang=js"
export * from "./Register_1.vue?vue&type=script&lang=js"

import "./Register_1.vue?vue&type=style&index=0&id=b5d65162&scoped=true&lang=css"

import exportComponent from "C:\\Users\\noklo\\Documents\\GitHub\\Rayong\\Rayong-query-community\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5d65162"]])

export default __exports__